import { composeReducers } from './composeReducers';

export {
    composeReducers
};
